export default [
    {
        path: '/ticket',
        component: () => import('@/views/ticket/list'),
    }
]